import { DrawerBody, DrawerFooter } from "@chakra-ui/react";
import Drawer from "./Drawer";
import DrawerTheme from "./theme";
export { Drawer, DrawerBody, DrawerFooter, DrawerTheme };
//# sourceMappingURL=index.js.map